// extracted by mini-css-extract-plugin
export default {"titleHeader":"ActivityDetailModal_titleHeader__5c84g","buttonClose":"ActivityDetailModal_buttonClose__z1sQl","activityValue":"ActivityDetailModal_activityValue__naKWH"};